<template>
  <div>
    <!-- Filtros -->
     <div class="w-full flex justify-between mt-4 below-top-bar">
        <div class="flex">
        </div>
    </div>

    <!-- Tabla de proyectos -->
    <div class="panel">

      <b-table
        :data="history"
        :loading="isLoadingTable"

        paginated
        backend-pagination
        :per-page="perPage"
        :total="total"
        @page-change="onPageChange"

        backend-sorting
        :default-sort="orderField"
        :default-sort-direction="orderDir"
        @sort="onSort"

        class="w-full text-sm"
        striped
        bordered
        icon-pack="fas"
      >

        <template>

          <b-table-column field="date" :label="$t('date')" sortable v-slot="props">
            {{ props.row.created_at }}
          </b-table-column>

          <b-table-column field="avatar" :label="$t('avatar')" width="40" v-slot="props">
            <figure class="">
              <p class="image is-50x50">
                <img class="rounded-full" :src="props.row.user.avatar">
              </p>
            </figure>
          </b-table-column>

          <b-table-column field="user" :label="$t('user')" sortable v-slot="props">
            {{ props.row.user.fullname }}
          </b-table-column>

          <b-table-column field="description" :label="$t('description')" sortable v-slot="props">
            {{ props.row.description }}
          </b-table-column>

          <b-table-column field="status" :label="$t('status')" sortable v-slot="props">
            <div class="flex items-center">
              <progress-circle :progress="props.row.progress" :status="props.row.status" />
              <span class="ml-2">{{ props.row.description_status }}</span>
            </div>
          </b-table-column>

          <b-table-column field="type" :label="$t('type')" sortable v-slot="props">
            {{ $t(props.row.type) }}
          </b-table-column>

          <b-table-column :label="$t('actions')" field="actions" centered width="100" v-slot="props">
            <div class="w-full h-full flex items-center justify-around">
              <b-tooltip v-if="props.row.progress == 100"
                :label="$t('download')" position="is-left">
                <div @click="downloadButtonClicked(props.row.id)"
                     class="cursor-pointer flex text-blue text-lg">
                  <b-icon pack="fas" icon="file-download"/>
                </div>
              </b-tooltip>
              <b-tooltip v-if="props.row.progress == 100"
                :label="$t('regenerate')" position="is-left">
                <div @click="loadButtonClicked(props.row.id)"
                     class="cursor-ponter text-lg">
                  <b-icon pack="fas" icon="undo"/>
                </div>
              </b-tooltip>
              <!-- solo quien lanzó el informe puede borrarlo (can_delete viene de ProcesslogPolicy) -->
              <b-tooltip v-if="props.row.can_delete" :label="$t('remove')" position="is-left" type="is-danger">
                <div @click="deleteButtonClicked(props.row.id, props.row.description)"
                     class="cursor-pointer flex text-red text-lg">
                  <b-icon pack="fas" icon="trash-alt"/>
                </div>
              </b-tooltip>
            </div>
          </b-table-column>

        </template>

        <template #empty>
          <div class="has-text-centered">{{ $t('no_results') }}</div>
        </template>
      </b-table>

    </div>

  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import axios from 'axios'
  import EventBus from '~/plugins/bus'
  import ProgressCircle from './components/progress-circle.vue'

  export default {

    components: {
      ProgressCircle,
    },

    props: {
      projectId: { type: Number, required: true },
      emitParentList: { type: Boolean, default: false }
    },

    computed: {
      filters() {
        let filters = {
          'project_id': this.projectId,
          'order_field': this.orderField,
          'order_dir': this.orderDir,
        }

        return filters
      }
    },

    data: function() {
      return {
        isLoadingTable: true,
        history: [],
        perPage: 20,
        orderField: 'name',
        orderDir: 'asc',
        page: 1,
        total: 0,
      }
    },

    created() {
      this.getHistory()

      EventBus.$on('processQueueLog', (e) => {
        let index = this.history.findIndex(h => h.id == e.data.id)
        if (index !== -1) {
          this.$set(this.history, index, {
            ...this.history[index],
            progress: e.data.progress,
            description_status: e.data.description_status,
            status: e.data.status,
          })
        }
      })
    },

    beforeDestroy() {
      EventBus.$off('processQueueLog')
    },

    methods: {

      async getHistory() {
        this.isLoadingTable = true
        this.history = []

        let params = {
          'project_id': this.projectId,
          'type': 'detailed_report',
          'order_field': this.orderField,
          'order_dir': this.orderDir,
          'page': this.page,
          'per_page': this.perPage,
        }

        const {data} = await axios.get(`/api/v2/process-logs`, {params: params})
        if (data && data.success) {
          this.history = data.process
          this.total = data.process.length
          this.isLoadingTable = false
        }
      },

      onSort(field, order) {
        this.projectId = this.projectId
        this.orderField = field
        this.orderDir = order
        this.getHistory()
      },

      onPageChange(page) {
        this.page = page
        this.getHistory()
      },

      cleanFiltersClicked() {
        this.filterTemplateName = ''
        this.getHistory()
      },

      reload() {
        this.getHistory();
      },

      async loadButtonClicked(row) {
        let url = '/api/v2/process-logs/' + row
        const {data} = await axios.get(url)
        if (data && data.success) {
          let payload = JSON.parse(data.process.payload)
          this.$emit('load-report', payload)
        } else {
          this.$notify.error(data.error)
        }
      },

      // El listado de process-logs no trae `name`: identificamos el registro por su descripción.
      deleteButtonClicked(id, description) {
        this.$dialog.confirm({
          title: this.$t('delete'),
          message: this.$t('delete_confirm_text', [this.$t('the_record'), description]),
          confirmText: this.$t('delete_record'),
          type: 'is-danger',
          hasIcon: true,
          onConfirm: async () => {
            let url = '/api/v2/process-logs/' + id + '/delete'
            try {
              const {data} = await axios.delete(url)
              if (data && data.success) {
                this.$notify.success('success_deleting_generic')
                this.getHistory()
              } else {
                this.$notify.error((data && data.error) || 'error_deleting')
              }
            } catch (response) {
              // el interceptor de axios rechaza con error.response (p. ej. 403 si no es tu proceso)
              this.$notify.error((response && response.data && response.data.error) || 'error_deleting')
            }
          }
        })
      },

      async downloadButtonClicked(id) {
        let url = '/api/v2/process-logs/' + id + '/download'
        const {data} = await axios.post(url)
        if (data && data.success) {
          this.$notify.success('generating');
          window.open(data.url);
          // this.download(data.url)
        } else {
          this.$notify.error(data.error)
        }
      },

      download(url) {
        const a = document.createElement("a");

        if (!a.click) {
          throw new Error('DownloadManager: "a.click()" is not supported.');
        }

        a.href = url;
        a.target = "_blank";

        if ("download" in a) {
          a.download = 'name';
        }

        (document.body || document.documentElement).append(a);
        a.click();
        a.remove();
      },

      archiveClass(value) {
        return value ? "cursor-pointer flex text-yellow-dark" : "cursor-pointer flex text-blue"
      },

      handleSelect(newRow, oldRow) {
        this.$emit('update:template', newRow);
      },

      clearSelected() {
        this.rowSelected = null
      }
    },

  };
</script>
